"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VasatConfig = exports.VasatStorage = exports.VasatError = void 0;
class VasatError {
    constructor(resp, error) {
        this.status = resp.status;
        this.message = resp.message;
        this.errorJson = resp.errorJson;
        if (resp.payload)
            this.payload = resp.payload;
        if (resp.throwable)
            this.throwable = resp.throwable;
        this.error = error;
    }
}
exports.VasatError = VasatError;
class VasatStorage {
    constructor() {
        this.ls = this.getLocalStorage();
    }
    set(key, v) {
        this.ls[key] = JSON.stringify(v);
    }
    get(key) {
        return (this.ls && this.ls[key]) ? JSON.parse(this.ls[key]) : null;
    }
    del(key) {
        if (this.ls)
            delete this.ls[key];
    }
    getWindow() {
        return (typeof (window) !== 'undefined') ? window : {};
    }
    getLocalStorage() {
        try {
            // Return current window localStorage. Note this will fail(throw an error) if cookies are disabled in the browser.
            return this.getWindow()['localStorage'];
        }
        catch (error) {
            // If error simply return an emtpy object to store values in memory
            return {};
        }
    }
}
exports.VasatStorage = VasatStorage;
class VasatConfig {
    constructor(host, clientId, clientSecret, debug) {
        this.host = host;
        this.clientId = clientId;
        this.clientSecret = clientSecret;
        this.debug = debug;
    }
}
exports.VasatConfig = VasatConfig;
